export const campaignConfig = {
    campaignListConfig: 'campaign_nescafestreetcafe_privileg',
};

export const campaignConfigLuckyDraw = {
    campaignListConfig: 'campaign_suntory_luckydraw',
};

export const campaignConfigMission = {
    campaignListConfig: 'campaign_suntory_mission',
};

export const dashboardConfig = {
    mainDashboard: 'nescafestreetcafe_promotion',
    welcomeDashboard: 'nescafestreetcafe_welcome_survey',
};

export const categoryConfig = {
    menuCategory: 'menu_nescafestreetcafe_menu',
};

export const SubscriptionConfig = {
    menuCategory: 'menu_nescafestreet_subscription',
};

export const SubscriptionItemConfig = {
    menuCategory: 'campaign_nescafestreet_subscription',
}

export const addonConfig = {
    menuCategory: 'campaign_nescafestreet_subscription_addon',
}

export const upsizeConfig = {
    menuCategory: 'campaign_nescafestreet_subscription_upsize',
}

export const categoryConfigLuckyDraw = {
    menuCategory: 'menu_suntory_luckydraw',
};

export const historyConfig = {
    purchase: 'purchase',
};
